import React from 'react';
import { ImageCarousel } from '@naf-simba/sections-image-carousel';
import ResponsiveImage from '@components/image/ResponsiveImage';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import utils from '../../../../../utils';

interface ImageCarouselSerializerProps {
  value: { images: CloudinaryImageType[] };
}

const ImageCarouselImage = ({ image: { publicId, caption, altText } }: { image: CloudinaryImageType }) => (
  <ResponsiveImage imageId={publicId} altText={altText || caption} />
);

export const ImageCarouselBlock = ({ value: { images } }: ImageCarouselSerializerProps) => {
  const isMobile = useMediaQuery('(max-width: 576px)');
  return (
    <ImageCarousel
      width={isMobile ? '350px' : '650px'}
      images={images.map((image) => ({
        render: () => <ImageCarouselImage image={image} />,
        description: `${image?.caption ? `${image?.caption}\n` : ''}${utils.getPhotographerAndCopyrightCaption({
          copyright: image?.copyright,
          photographer: image?.photographer,
        })}`,
      }))}
    />
  );
};
